import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import qs from 'qs';
import _ from 'lodash';
import { Card, Loading } from '../components';
import { getDmService, reqToken } from '../services/Api';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: '',
      senha: '',
      // error: null,
    };
  }

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  login = async (user, pass) => {
    const { history, location } = this.props;
    const query = qs.parse(location.search);
    this.setState({ isLoading: true })

    reqToken(`username=${user}&password=${pass}&grant_type=password`)
      .then(data => {
        const token = data.access_token;
        localStorage.setItem('user_token', token);

        getDmService('/Usuario/Me').then(innerData => {
          localStorage.setItem('user', JSON.stringify(innerData));
          const nivelDesigner = innerData && innerData.nivel.id === 40;
          const nivelGerente = innerData && innerData.nivel.id === 45;
          if (_.isEmpty(query)) {
            history.replace('/');
          } else if (query && query['?r']) {
            const redirect = query['?r'].replace(window.location.origin, '');
            history.replace(redirect);
          }
          if (nivelDesigner || nivelGerente) {
            history.push('/admin/agencia/pedidos');
          }
          this.setState({ isLoading: false })
        });
      })
      .catch(err => {
        if (err.code !== 500) {
          console.log(err);
          if (err.code === 400 && err.message) toast.error(err.message);
          else toast.error(err.message);
        }
        this.setState({ isLoading: false })
      });
  };

  onsubmit = e => {
    const { email, senha } = this.state;
    e.preventDefault();
    if (e.target.checkValidity()) {
      this.login(email, senha);
    }
  };

  render() {
    const { email, senha, isLoading } = this.state;

    return (
      <form className="login-block" onSubmit={this.onsubmit}>
        {isLoading && (
          <Loading text="Carregando..." />
        )}
        <Card>
          <img
            className="logo-login"
            src={require('../../src/assets/images/logo_dmjob.png')}
            alt="Logotipo Dm Job"
          />
          <div className="bx--col-md-12 v-md-margin">
            <label className="bx--label">E-mail</label>
            <input
              type="email"
              className="bx--text-input"
              required
              placeholder="E-mail"
              name="email"
              value={email}
              onChange={this.onChangeText}
            />
          </div>
          <div className="bx--col-md-12 v-md-margin">
            <label className="bx--label">Senha</label>
            <input
              type="password"
              className="bx--text-input"
              required
              placeholder="Senha"
              name="senha"
              value={senha}
              onChange={this.onChangeText}
            />
          </div>
          <div className="bx--col-md-12 v-md-margin">
            <NavLink to="/esqueci-senha" className="underline login-link">
              Esqueceu a senha?
            </NavLink>
          </div>
          <div className="bx--col-md-12">
            <button
              className="bx--btn btn-secondary-color v-md-margin btn-login"
              disabled={!email || !senha}
              type="submit"
            >
              Entrar
            </button>
            <NavLink to="/cadastro" className="btn-nova-conta">
              Nova Conta
            </NavLink>
          </div>
        </Card>
      </form>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/screens/login.js